/**
 * ＣＷＳカテゴリ変換マスタ一覧用VOクラス
 */
export class KYMW6800commonModel {

  // 処理区分(0：登録)
  public static PROCES_DIV_REGIST: string = <string>'0';
  // 処理区分(1：更新)
  public static PROCES_DIV_UPDATE: string = <string>'1';
  // 番号未設定
  public static UNDEFINED_NUMBER: string = <string>'0';
  // コード値未設定
  public static UNDEFINED_CODE: string = <string>'*';

  // 共通
  public categoryDiv: string = <string>'';                                      // カテゴリ区分
  public categoryCode: string = <string>'';                                     // カテゴリコード
  public stockLimitFlg: string = <string>'';                                       // 在庫限定

  // カテゴリ情報ツリー
  public rootList: Array<any> = null;                                           // 第１階層カテゴリ情報リスト
  public childList: Array<any> = null;                                          // 第２～４階層カテゴリ情報リスト
  public orderCode: string = <string>'';                                        // 受注コード
  public categoryName: string = <string>'';                                     // カテゴリ名称
  public parentCategoryCode: string = <string>'';                               // 親カテゴリコード
  public categoryLevel: string = <string>'';                                    // カテゴリ階層
  public ShowSeq: string = <string>'';                                          // 表示順
  public timeSaleFlg: string = <string>'';                                      // タイムセールフラグ

  // CWS用カテゴリ変換マスタ一覧
  public categoryConvList: Array<any> = null;                                   // カテゴリ変換マスタ情報リスト
  public categoryConvID: string = <string>'';                                   // カテゴリ変換ＩＤ
  public convDiv: string = <string>'';                                          // 変換区分
  public classDivNum: string = <string>'';                                      // 部門分類管理NO
  public classCode: string = <string>'';                                        // 部門コード
  public largeClassCode: string = <string>'';                                   // 大分類コード
  public middleClassCode: string = <string>'';                                  // 中分類コード
  // 項番2632 START
  public smallClassCode: string = <string>'';                                   // 小分類コード
  // 項番2632 END
  public markCode1: string = <string>'';                                        // マークコード１
  public markCode2: string = <string>'';                                        // マークコード２
  public markCode3: string = <string>'';                                        // マークコード３
  public pricePattern: string = <string>'';                                     // 価格パターン
  public mediumType: string = <string>'';                                       // 媒体区分
  public featureCode: string = <string>'';                                      // 特集
  public pageNum: string = <string>'';                                          // ページ番号
  public promotionDiv: string = <string>'';                                     // プロモーション区分
  public promotionInfo: string = <string>'';                                    // プロモーション情報
  public exhibitionDiv: string = <string>'';                                    // 催事区分
  public tag1: string = <string>'';                                             // タグ１
  public tag2: string = <string>'';                                             // タグ２

  // 登録・更新用
  public procesDiv: string = <string>'';                                        // 処理区分
  public updateDate: string = <string>'';                                       // 更新日時

}
